// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfe_a bhc_wh bhc_sq bhc_xj"};